// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"152":"dc60915fc8200f7f","158":"dfe28db5faf2b520","213":"4751a940f51c925e","431":"f23a82310691e2eb","461":"1135f3e9cfb7529e","661":"8ee43c44009525fe","685":"6a49337a0e449288","846":"895afdf9b901fae4","957":"1684ff3353d80ff3","979":"bf1385fb0b1c1fc3","986":"48364cef1d0a581a"}[chunkId] + ".js";
};